export default __webpack_public_path__ + "d9da6d0502457a94bbc8b40f8835e453.png";